








































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3, logoutPanel } from "@/components";
import { TbGoods, TbTransferOrder, TbShop } from '@/http';
import { warn } from 'console';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
import { log } from 'util';
@Component({
    components: {
        padHeadPanel3, logoutPanel
    },
})
export default class viewAllot extends Vue {
    public $refs: {
    };
    //获取到的调拨单id
    id = "";
    //获取到的调拨单详情信息
    form: any = {};

    /**其他店铺库存 */
    show = false;

    otherList = [];

    /**提示弹窗 */
    tipShow = false;
    tipTitle = "";
    tipText = "";
    confirmText = "";
    cancelText = "";
    btnNums = 2;

    userInfo: any = {};
    //门店信息
    shopOptions = []

    loadingbtn = false;
    activetype = null;

    created() {
        this.id = this.$route.query.id;
        this.activetype = this.$route.query.allotactive;
        console.log('this.activetype', this.activetype)
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
    }
    async mounted() {
        await this.getshopList();
        await this.init();
    }
    //获取总额
    get allmoney() {
        let val = 0;
        if (this.form.details && this.form.details.length > 0) {
            let arr = this.form.details.map(v => calculate.multiplication(v.sellingPrice, v.num));
            val = arr.reduce((a, b) => calculate.addition(a, b));
        }
        return val;
    }
    //获取数量
    get allnum() {
        let val = 0;
        if (this.form.details && this.form.details.length > 0) {
            let arr = this.form.details.map(v => v.num);
            val = arr.reduce((a, b) => (Number(a) + Number(b)).toFixed(0))
        }
        return val;
    }
    async init() {
        let res = await TbTransferOrder.GetTbTransferOrderByIdV2(this.id);
        console.log('ress', res);
        this.form = res;
    }
    /**获取门店下拉 */
    async getshopList() {
        let res = await TbShop.GetTbShoppListForSwitch({
            shopId: this.userInfo.shopId,
        })
        this.shopOptions = res;
        console.log('this.shopOptions', this.shopOptions);
    }
    /**门店选中信息 */
    getShopname(val) {
        let str = ""
        str = this.shopOptions.findIndex(v => v.id == val) > -1 ? this.shopOptions.find(v => v.id == val).shopName : '';
        return str;
    }
    //接收调拨按钮点击
    async receiveAllot() {
        if (this.loadingbtn) return;
        this.loadingbtn = true;
        try {
            let res = await TbTransferOrder.PutTransferOrderStatusV2({ id: this.form.id });
            this.loadingbtn = false;
            Toast("接收调拨成功");
            localStorage.setItem('allotactive', '2')
            this.$router.go(-1);
        } catch {
            this.loadingbtn = false;
        }

    }
    /**提示弹窗 */
    async tipConfirm() {
        this.tipShow = false;
    }
    tipCancel() {
        this.tipShow = false;
    }
    formatZero(val) {
        let nval = val.toString();
        if (nval.indexOf(".") == -1) {
            nval += ".00";
        } else {
            let arrayNum = nval.split(".");
            if (arrayNum[1].length < 2) {
                nval += "0";
            }
        }
        return nval;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/allot/viewAllot.vue